import BlueImage from "./BlueImage";
import styles from "./MainArticleBackgroundImage.scss";
import classNames from "classnames";
const cx = classNames.bind(styles);

const MainArticleBackgroundImage = ({ className, ...props }) => <BlueImage className={`${cx("blue-image")} ${className}`} {...props} />;

export default MainArticleBackgroundImage;
